import clsx from 'clsx';
import { Label } from '../Label';
import { ChangeEvent } from 'react';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';

interface Props extends BaseProps {
  checked?: boolean;
  color?: ColorVariant | 'sand';
  direction?: FlexDirection;
  label: string;
  onChange?(event: ChangeEvent<HTMLInputElement>): any;
  position?: FlexPosition;
  required?: boolean;
  size?: SizeVariant;
}

export const Checkbox = (props: Props) => {
  const {
    checked,
    className,
    color = 'primary',
    direction = 'row',
    disabled = false,
    label,
    onChange,
    position = 'end',
    required = false,
    size = 'medium',
    ...rest
  } = props;
  const classes = useStyles();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange !== undefined) onChange(event);
  };

  return (
    <Label
      id={`label-${label}`}
      htmlFor={label}
      aria-label={label}
      aria-disabled={disabled}
      direction={direction}
      required={required}
      align="center"
      text={label}
      opacity="full"
      position={position}
    >
      <span className="relative">
        <input
          id={label}
          aria-required={required}
          aria-disabled={disabled}
          className={clsx(classes.input.default, classes.input.color[color])}
          checked={checked}
          onChange={handleChange}
          required={required}
          tabIndex={0}
          type="checkbox"
          {...rest}
        />
        {checked ? (
          <CheckBox
            className={clsx(classes.icon, classes.input.color[color], {
              [classes.disabled]: disabled,
            })}
            fontSize={size}
          />
        ) : (
          <CheckBoxOutlineBlank
            className={clsx(classes.icon, { [classes.disabled]: disabled })}
            fontSize={size}
          />
        )}
      </span>
    </Label>
  );
};

const useStyles = () => ({
  disabled: 'cursor-default opacity-70 pointer-events-auto',
  icon: 'top-0 left-0 pointer-events-none',
  input: {
    default: 'absolute cursor-pointer appearance-none w-6 h-6 opacity-0',
    size: {
      small: '',
      medium: '',
      large: '',
    },
    color: {
      primary: 'accent-primary text-primary',
      sand: 'accent-sand text-sand',
      secondary: 'accent-secondary text-secondary',
    },
  },
  container: {
    default: 'flex gap',
    row: 'flex-row',
    column: 'flex-col',
  },
});
